<style scope>
	.line-box {
		display: flex; flex-direction: row; height: 60px; align-items: center;
	}
	.line-name {
		width: 130px; text-align: right; padding-right: 10px;
	}
	.line-tag-box {
		display: flex; flex-direction: row;  align-items: center;
	}
	.line-tag {
		width: 700px;  background-color: #f2dede; color: #b94a48; line-height: 20px; padding: 10px; border-radius: 3px;
	}
	
	.upload-box {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 60px;
	    height: 60px;
	    line-height: 60px;
	    text-align: center;
	  }
	  .avatar {
	    width: 60px;
	    height: 60px;
	    display: block;
	  }
</style>

<template>
	<div>
		<div class="line-box">
			<div class="line-name">UID：</div>
			<el-input style="width: 720px;" placeholder="" disabled v-model="userInfo.uid"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">昵称：</div>
			<el-input style="width: 720px;" placeholder="" v-model="userInfo.nickname"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">账号：</div>
			<el-input style="width: 720px;" placeholder="" v-model="userInfo.username"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">密码：</div>
			<el-input style="width: 720px;" placeholder="重置密码" v-model="userInfo.password"></el-input>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">注意： 重置修改密码的时候才填写，不修改留空</div>
		</div>
		<div class="line-box">
			<div class="line-name">到期时间：</div>
			<el-input style="width: 720px;"  v-model="userInfo.end_time"></el-input>
		</div>
		
		<div class="line-box">
			<div class="line-name">打印权限：</div>
			<el-checkbox-group v-model="permission_list" @change="print_change">
				<el-checkbox label="竞彩足球" key="is_football">竞彩足球</el-checkbox>
				<el-checkbox label="竞彩篮球" key="is_basketball">竞彩篮球</el-checkbox>
				<el-checkbox label="北京单场" key="is_peking">北京单场</el-checkbox>
				<el-checkbox label="排列三" key="is_pl3">排列三</el-checkbox>
				<el-checkbox label="冠亚军" key="is_gyj">冠亚军</el-checkbox>
				<el-checkbox label="自动打印" key="is_auto">自动打印</el-checkbox>
			</el-checkbox-group>
		</div>
	<!-- 	
		<div class="line-box">
			<div class="line-name">自动打印：</div>
			<el-checkbox-group v-model="userInfo.auto_list" @change="auto_change">
				<el-checkbox label="lucky" key="lucky">幸运门店</el-checkbox>
				<el-checkbox label="hyll" key="hyll">好运连连</el-checkbox>
				<el-checkbox label="hxyj" key="hxyj">彩站云</el-checkbox>
				<el-checkbox label="p7" key="xld">P7</el-checkbox>
				<el-checkbox label="fqy" key="fqy">番茄云</el-checkbox>
				<el-checkbox label="xds" key="xds">喜得胜</el-checkbox>
				<el-checkbox label="zyb" key="zyb">州运宝</el-checkbox>
				<el-checkbox label="htzs" key="htzs">鸿图助手</el-checkbox>
				<el-checkbox label="ddl" key="ddl">叮咚乐</el-checkbox>
			</el-checkbox-group>
		</div> -->
		
		<div class="line-box">
			<div class="line-name">自动打印：</div>
			<div style="width: 600px;">
				<el-checkbox-group v-model="userInfo.auto_arr">
					<el-checkbox :label="plat.id" :key="plat.id" v-for="(plat,index) in platList">{{plat.app_name}}</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		
		
		<div class="line-box">
			<div class="line-name">续费RMB：</div>
			<el-input style="width: 720px;"  v-model="userInfo.hour_rmb"></el-input>
		</div>
		
		<div class="line-box">
			<div class="line-name">续费USDT：</div>
			<el-input style="width: 720px;"  v-model="userInfo.hour_usdt"></el-input>
		</div>
		
		<div class="line-box">
			<div class="line-name">接口地址：</div>
			<el-input style="width: 720px;"  v-model="userInfo.api_url"></el-input>
		</div>
		
		<div class="line-box">
			<div class="line-name">机器码：</div>
			<el-input style="width: 720px;" disabled  v-model="userInfo.machine_id"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">机器码：</div>
			<el-input style="width: 720px;" disabled  v-model="userInfo.machine_id2"></el-input>
		</div>
		<div style="width: 100%; margin-top: 20px;">
			<el-button style="width: 100%;" type="danger" @click="addProduct">确认修改</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:['userInfo', 'uid'],
		watch:{
			uid(new1,old){
				this.permission_list = this.userInfo.print_permission;
			}
		},
		data(){
			return {
				editStatus : false,
				auto_list:[],
				permission_list:[],
				headers:{
					Authorization:''
				},
				platList:[],
			}
		},
		created() {
			this.getPlatList();
			this.headers.Authorization = localStorage.getItem('access_token');
			this.permission_list = this.userInfo.print_permission;
		},
		methods: {
			getPlatList(){
				let that = this;
				that.$api.post("/System/getAutoPlatList", {}).then(res=>{
					let _list = res.data.list;
					_list = _list.filter( item => item.is_service === 0);
					that.platList = _list;
				}).catch(res=>{
				});
			},
			auto_change(e){
				
			},
			print_change(e){
			},
			addProduct() {
				// 验证格式
				if(this.userInfo.username == ""){
					return this.$message({ message: '请填写账号', type: 'warning' });
				}
				// 提交保存
				this.submit();
			},
			submit(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '编辑中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				this.userInfo.print_permission = this.permission_list;
				//this.userInfo.auto_list = this.auto_list;
				_this.$api.post("/User/editUser", this.userInfo).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.$emit('close-dialog');
						_this.$message({
							 message: '编辑成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
					
				}).catch(err=>{
					loading.close();
				});
			},
		},
	}
</script>
